var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.875,
    y1: 558.595,
    x2: -38.875,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M280,400.136c-4.418,0-8,3.582-8,8V416H16V64h256v7.36c0,4.418,3.582,8,8,8s8-3.582,8-8V40 c-0.026-22.08-17.92-39.974-40-40H40C17.92,0.026,0.026,17.92,0,40v400c0.026,22.08,17.92,39.974,40,40h208 c22.08-0.026,39.974-17.92,40-40v-31.864C288,403.718,284.418,400.136,280,400.136z M40,16h208c13.255,0,24,10.745,24,24v8H16v-8 C16,26.745,26.745,16,40,16z M248,464H40c-13.255,0-24-10.745-24-24v-8h256v8C272,453.255,261.255,464,248,464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.875,
    y1: 558.595,
    x2: -36.875,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M152,40h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16c-4.418,0-8,3.582-8,8S147.582,40,152,40z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.875,
    y1: 558.595,
    x2: -38.875,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M160,440h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S164.418,440,160,440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.375,
    y1: 558.595,
    x2: -41.375,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M120,40h8c4.418,0,8-3.582,8-8s-3.582-8-8-8h-8c-4.418,0-8,3.582-8,8S115.582,40,120,40z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.375,
    y1: 558.595,
    x2: -50.375,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M48,120V96h24V80H32v40H48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.375,
    y1: 558.595,
    x2: -50.375,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M32,360v40h40v-16H48v-24H32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -24.8887,
    y1: 558.595,
    x2: -24.8887,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M472,192H312c-4.418,0-8,3.582-8,8v40H176c-0.016-5.386-0.639-10.753-1.856-16H240 c4.418,0,8-3.582,8-8V112h72.472c4.418,39.518,40.036,67.972,79.554,63.554c39.518-4.418,67.972-40.036,63.554-79.554 c-4.418-39.518-40.036-67.972-79.554-63.554C350.596,36.183,324.21,62.57,320.472,96H240c-4.418,0-8,3.582-8,8v104h-63.6 c-17.65-35.657-60.865-50.255-96.522-32.604s-50.255,60.865-32.604,96.522s60.865,50.255,96.522,32.604 c8.399-4.157,15.906-9.914,22.1-16.946c0.678,0.238,1.386,0.381,2.104,0.424h72v88c0,4.418,3.582,8,8,8h64v40c0,4.418,3.582,8,8,8 h160c4.418,0,8-3.582,8-8v-96c0-0.192-0.096-0.352-0.104-0.536c-0.053-0.543-0.16-1.079-0.32-1.6 c-0.124-0.522-0.304-1.028-0.536-1.512c-0.049-0.175-0.111-0.346-0.184-0.512c-0.193-0.24-0.402-0.467-0.624-0.68 c-0.322-0.442-0.689-0.85-1.096-1.216c-0.392-0.307-0.812-0.575-1.256-0.8c-0.433-0.255-0.888-0.469-1.36-0.64 c-0.521-0.162-1.057-0.269-1.6-0.32c-0.302-0.082-0.609-0.144-0.92-0.184H312c-0.308,0.041-0.612,0.103-0.912,0.184 c-0.544,0.049-1.081,0.159-1.6,0.328c-0.473,0.16-0.926,0.372-1.352,0.632c-0.45,0.238-0.874,0.522-1.264,0.848 c-0.408,0.359-0.776,0.761-1.096,1.2c-0.221,0.218-0.429,0.447-0.624,0.688c-0.071,0.167-0.132,0.338-0.184,0.512 c-0.232,0.484-0.412,0.99-0.536,1.512c-0.16,0.521-0.267,1.057-0.32,1.6c0,0.184-0.104,0.344-0.104,0.536v40H248V280 c0-4.418-3.582-8-8-8h-71.6c2.546-5.085,4.475-10.457,5.744-16H304v40c0,4.418,3.582,8,8,8h160c4.418,0,8-3.582,8-8v-96 C480,195.582,476.418,192,472,192L472,192z M392,48c30.928,0,56,25.072,56,56s-25.072,56-56,56s-56-25.072-56-56 C336.04,73.089,361.089,48.04,392,48z M320,416v-73.872l67.88,40.728c2.535,1.523,5.705,1.523,8.24,0L464,342.128V416H320z  M340.88,336h102.24L392,366.672L340.88,336z M104,296c-30.928,0-56-25.072-56-56s25.072-56,56-56s56,25.072,56,56 C159.96,270.911,134.911,295.96,104,296z M464,208v16H320v-16H464z M320,288v-48h144v48H320z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.875,
    y1: 558.595,
    x2: -7.875,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M392,128c-4.418,0-8-3.582-8-8s-3.582-8-8-8s-8,3.582-8,8 c0.042,10.134,6.445,19.15,16,22.528V152h16v-9.472c12.473-4.393,19.023-18.066,14.629-30.539 C411.249,102.393,402.174,95.981,392,96c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8s3.582,8,8,8s8-3.582,8-8 c-0.042-10.134-6.445-19.15-16-22.528V56h-16v9.472c-12.473,4.393-19.023,18.066-14.629,30.539 c3.38,9.596,12.455,16.009,22.629,15.989c4.418,0,8,3.582,8,8S396.418,128,392,128z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.8203,
    y1: 558.595,
    x2: -43.8203,
    y2: 617.365,
    gradientTransform: "matrix(8 0 0 -8 455 4941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E7F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M141.256,218.744c-3.124-3.123-8.188-3.123-11.312,0L96,252.688L79.032,235.72 c-3.069-3.178-8.134-3.266-11.312-0.197c-3.178,3.069-3.266,8.134-0.197,11.312c0.064,0.067,0.13,0.132,0.197,0.197l22.624,22.624 c3.124,3.123,8.188,3.123,11.312,0l39.6-39.6C144.379,226.932,144.379,221.868,141.256,218.744L141.256,218.744z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities);
export default __webpack_public_path__ + "static/media/utilities.8545edeed12a0fd9b67e92f073ec845d.svg";
export { ForwardRef as ReactComponent };